import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { parseISO } from 'date-fns';
import { bem } from 'helpers/class-name';
import { VENUE_SOURCE } from 'constants/logic';
import Message from 'components/Message';

import { VENUE_SOURCE_DISPLAY_NAME } from './AutoSyncStatus.helpers';

import './AutoSyncStatus.scss';

const messages = defineMessages({
  autoSyncOn: {
    id: 'auto-sync-status.status.on',
    defaultMessage: 'AutoSync On',
  },
  autoSyncOff: {
    id: 'auto-sync-status.status.off',
    defaultMessage: 'AutoSync Off',
  },
  lastUpdate: {
    id: 'auto-sync-status.status.last-update',
    defaultMessage: 'Last sync {date, date, medium-w-dow-time-no-year}',
  },
});

const { block, element } = bem('auto-sync-status');

const AutoSyncStatus = ({ autosyncStatus, autosyncSource, autosyncLastSyncDatetime, venueSource }) => {
  const statusMessage = autosyncStatus ? messages.autoSyncOn : messages.autoSyncOff;

  let integratorName = venueSource && VENUE_SOURCE_DISPLAY_NAME[venueSource];

  if (venueSource === VENUE_SOURCE.MSINVENTORY && autosyncStatus && autosyncSource) {
    const trimmedWebsite = autosyncSource.replace(/^https?:\/\//, '');

    if (trimmedWebsite) {
      integratorName = (
        <a href={autosyncSource} className={element('link')} target="_blank" rel="noopener noreferrer">
          {trimmedWebsite}
        </a>
      );
    }
  }

  return (
    <span className={block()}>
      <span>
        <span className={element('indicator-dot', { isEnabled: autosyncStatus })} />
        <Message message={statusMessage} className="mr-r" />
        <span className={element('integrator-name')}>{integratorName}</span>
      </span>
      {autosyncStatus && (
        <span className="text--light">
          <Message
            message={messages.lastUpdate}
            values={{ date: autosyncLastSyncDatetime && parseISO(autosyncLastSyncDatetime) }}
          />
        </span>
      )}
    </span>
  );
};

AutoSyncStatus.propTypes = {
  autosyncStatus: PropTypes.bool,
  autosyncSource: PropTypes.string,
  autosyncLastSyncDatetime: PropTypes.string,
  venueSource: PropTypes.string,
};

export default AutoSyncStatus;
